<div class="checkin-page">
  <p-card styleClass="checkin-card">
    @switch (state()) {
      @case ('submitting') {
        <div class="state state--center">
          <p-progressSpinner
            strokeWidth="4"
            [style]="{ width: '3rem', height: '3rem' }"
          />
          <p class="state__title">
            {{ 'controlPoints.checkin.submitting' | translate }}
          </p>
        </div>
      }

      @case ('success') {
        <div class="state">
          <i class="fa-solid fa-circle-check state__icon state__icon--success"></i>
          <h1 class="state__title">
            {{ 'controlPoints.checkin.successTitle' | translate }}
          </h1>
          <dl class="state__details">
            <dt>{{ 'controlPoints.checkin.controlPointLabel' | translate }}</dt>
            <dd>{{ controlPointName() ?? tag() }}</dd>
            @if (checkedInAt(); as ts) {
              <dt>{{ 'controlPoints.checkin.timeLabel' | translate }}</dt>
              <dd>{{ ts | date: 'dd.MM.yyyy HH:mm' : 'Europe/Berlin' }}</dd>
            }
          </dl>
        </div>
      }

      @case ('rejected') {
        <div class="state">
          <i class="fa-solid fa-ban state__icon state__icon--rejected"></i>
          <h1 class="state__title">
            {{ 'controlPoints.checkin.rejectedTitle' | translate }}
          </h1>
          <p class="state__message">
            {{ 'controlPoints.checkin.rejectedMessage' | translate }}
          </p>
          @if (missingQualifications().length) {
            <ul class="state__quals">
              @for (q of missingQualifications(); track q) {
                <li>{{ q }}</li>
              }
            </ul>
          }
        </div>
      }

      @case ('forbidden') {
        <div class="state">
          <i class="fa-solid fa-lock state__icon state__icon--rejected"></i>
          <h1 class="state__title">
            {{ 'controlPoints.checkin.forbiddenTitle' | translate }}
          </h1>
          <p class="state__message">
            {{ 'controlPoints.checkin.forbiddenMessage' | translate }}
          </p>
        </div>
      }

      @case ('unknown') {
        <div class="state">
          <i class="fa-solid fa-circle-question state__icon state__icon--rejected"></i>
          <h1 class="state__title">
            {{ 'controlPoints.checkin.unknownTitle' | translate }}
          </h1>
          <p class="state__message">
            {{ 'controlPoints.checkin.unknownMessage' | translate }}
          </p>
        </div>
      }

      @case ('error') {
        <div class="state">
          <i class="fa-solid fa-wifi state__icon state__icon--error"></i>
          <h1 class="state__title">
            {{ 'controlPoints.checkin.errorTitle' | translate }}
          </h1>
          <p class="state__message">
            {{ 'controlPoints.checkin.errorMessage' | translate }}
          </p>
          <p-button
            [label]="'controlPoints.checkin.retry' | translate"
            icon="fa-solid fa-arrows-rotate"
            styleClass="state__action"
            (onClick)="retry()"
          />
        </div>
      }
    }
  </p-card>
</div>
